import React, { Component } from "react";
import { connect } from 'react-redux';
import { State } from '../../reducers';
import { timerService } from '../../services/TimerService';

interface GlobalTimerProps {
    activityStatus: string;
    globalElapsedTime: number; // Full-session clock from TimerService
    dispatch: any;
}

interface GlobalTimerState {}

class GlobalTimer extends Component<GlobalTimerProps, GlobalTimerState> {
    constructor(props: GlobalTimerProps) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        // ExerciseManager constructor owns timerService.initialize().
        // GlobalTimer only starts timers if the workout is already active on mount
        // (e.g. hot-reload edge cases).
        const { isGlobalRunning } = timerService.getState();
        if (!isGlobalRunning) {
            if (this.props.activityStatus === 'hang' || this.props.activityStatus === 'rest') {
                timerService.startGlobalTimer();
                timerService.startRepTimer();
            }
        }
    }

    componentDidUpdate(prevProps: GlobalTimerProps) {
        if (this.props.activityStatus === prevProps.activityStatus) return;

        const timerState = timerService.getState();
        console.log('GlobalTimer: activityStatus', prevProps.activityStatus, '→', this.props.activityStatus);

        switch (this.props.activityStatus) {
            case 'get ready':
                // Only start from a fully stopped/reset state to avoid double-start
                if (!timerState.isGlobalRunning) {
                    console.log('GlobalTimer: Starting global timer for get ready phase');
                    timerService.startGlobalTimer();
                }
                break;
            case 'hang':
            case 'rest':
                if (!timerState.isGlobalRunning) {
                    console.log('GlobalTimer: Starting global timer for', this.props.activityStatus);
                    timerService.startGlobalTimer();
                }
                if (!timerState.isRepRunning) {
                    console.log('GlobalTimer: Starting rep timer for', this.props.activityStatus);
                    timerService.startRepTimer();
                }
                break;
            case 'pause':
                console.log('GlobalTimer: Pausing timers');
                timerService.pauseTimers();
                break;
            case 'stop':
            case 'reset':
                console.log('GlobalTimer: Resetting all timers');
                timerService.resetAllTimers();
                break;
            default:
                break;
        }
    }

    render() {
        const { globalElapsedTime } = this.props;
        const minutes = Math.floor(globalElapsedTime / 60);
        const seconds = Math.floor(globalElapsedTime % 60);

        return (
            <span className='timerPosition'>
                <h3>
                    <span>{("0" + minutes).slice(-2)}:{("0" + seconds).slice(-2)}</span>
                </h3>
            </span>
        );
    }
}

const mapStateToProps = (state: State) => ({
    activityStatus: state.activities.activityStatus,
    globalElapsedTime: state.activities.globalTimer?.elapsedTime || 0,
});

export default connect(mapStateToProps)(GlobalTimer);